var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.000000, -627.000000)",
    fill: "#0F428C"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.000210, 627.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2632855,0 C17.745272,0 22.9999602,5.14872538 22.9999602,11.5 C22.9999602,17.8512746 17.745272,23 11.2632855,23 C6.38120075,23 2.19533276,20.0792518 0.426421692,15.923796 L3.02844799,15.9233971 C4.62470814,18.7703813 7.71401588,20.7 11.2632855,20.7 C16.4488747,20.7 20.6526253,16.5810197 20.6526253,11.5 C20.6526253,6.4189803 16.4488747,2.3 11.2632855,2.3 C7.24310081,2.3 3.81303006,4.77562876 2.47433836,8.25589479 L-4.85167462e-14,8.2561973 C1.42910822,3.48437117 5.93091327,0 11.2632855,0 Z M9.52274273,7.2985119 C9.82561721,7.00211802 10.3156022,7.00314532 10.6171225,7.30109917 C10.918604,7.59897692 10.9174433,8.08077868 10.6145301,8.37724866 L10.6145301,8.37724866 L7.89988033,11.0339119 L16.5009297,11.0339119 C16.9283123,11.0339119 17.274753,11.3745936 17.274753,11.7948718 C17.274753,12.2151499 16.9283123,12.5558317 16.5009297,12.5558317 L16.5009297,12.5558317 L7.89984164,12.5558316 L10.6145688,15.2124948 C10.917482,15.5089648 10.9186427,15.9907666 10.6171611,16.2886443 C10.3156409,16.5865601 9.82569459,16.5876635 9.52278142,16.2912316 L9.52278142,16.2912316 L5.47870303,12.3335172 C5.17656369,12.0370472 5.17559641,11.5536855 5.47936078,11.2555034 L5.47936078,11.2555034 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log-out-icon.d073a0c3faf68c75d08eabb9fdc30c01.svg";
export { ForwardRef as ReactComponent };